module.exports = __webpack_public_path__ + "static/media/adria.6c41e380.png";